"use client";

import { useEffect, useState } from "react";
import NoSearchFound from "../components/NoSearchFound";
import CoursesGrid from "../app/[lang]/browsecourses/CoursesGrid";

export default function CoursesLoader({ params, searchParams }) {
  const [courses, setCourses] = useState([]);
  const [pagination, setPagination] = useState(null);

  useEffect(() => {
    const data = localStorage.getItem("searchData");

    if (data) {
      try {
        const parsed = JSON.parse(data);
        setCourses(parsed?.data || parsed);
        setPagination(parsed?.meta?.pagination || null);
        localStorage.removeItem("searchData");
      } catch (err) {
        console.error("Failed to parse searchData:", err);
      }
    }
  }, []);

  return courses.length > 0 ? (
    <CoursesGrid
      searchParams={searchParams}
      initialCourses={courses}
      initialPagination={pagination}
      params={params}
    />
  ) : (
    <NoSearchFound />
  );
}
